import { render, staticRenderFns } from "./ProduceA.vue?vue&type=template&id=8ba7c03e&"
import script from "./ProduceA.vue?vue&type=script&lang=js&"
export * from "./ProduceA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports